import { render, staticRenderFns } from "./EditJiFen.vue?vue&type=template&id=bfc039b6&scoped=true&"
import script from "./EditJiFen.vue?vue&type=script&lang=js&"
export * from "./EditJiFen.vue?vue&type=script&lang=js&"
import style0 from "./EditJiFen.vue?vue&type=style&index=0&id=bfc039b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc039b6",
  null
  
)

export default component.exports